import { appApplicationType, appUserRoles } from "../consts";

const isUserAdmin = (user) => {
  return Boolean(
    (!user.groups && user.roles) ||
      user.groups?.some((role) => role.appType === appApplicationType.id)
  );
};

const isAdminWithAdminRole = (user) => {
  return user.roles?.some((role) => role.role === appUserRoles.Admin);
};

const adminUserUtils = { isUserAdmin, isAdminWithAdminRole };

export default adminUserUtils;
